import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html'
})

export class NotFoundComponent implements OnInit {

  loginUrl: any;

  constructor() { }

  ngOnInit(): void {
    this.loginUrl = `${environment.loginUrl}`;
    sessionStorage.clear();
  }
}
